import { Icon } from "@opendash/icons";
import { Tag } from "antd";
import React from "react";
type StatusTagProps = React.PropsWithChildren & {
  status?: string;
};
const StatusTag = ({ status }: StatusTagProps) => {
  if (!status) {
    return <Tag color="red">?</Tag>;
  }
  if (status === "running") {
    return <Tag color="green" icon={<Icon icon="fa:play" />} />;
  }
  if (status === "done") {
    return <Tag color="blue" icon={<Icon icon="fa:check" />} />;
  }
};

export default StatusTag;
export type { StatusTagProps };
